import { render, staticRenderFns } from "./TableElement.vue?vue&type=template&id=c59a440a&scoped=true&"
import script from "./TableElement.vue?vue&type=script&lang=js&"
export * from "./TableElement.vue?vue&type=script&lang=js&"
import style0 from "./TableElement.vue?vue&type=style&index=0&id=c59a440a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59a440a",
  null
  
)

export default component.exports